









































import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, ProfileFilter } from 'client-website-ts-library/filters';
import { Profile, WebsiteLevel, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { View } from 'client-website-ts-library/plugins';

import Panels from '@/components/Panels.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Loader from '../components/UI/Loader.vue';

@Component({
  components: {
    ProfileCards,
    Loader,
    Panels,
  },
})
export default class OurAgents extends Mixins(View) {
  private profiles: Profile[] = [];

  mounted() {
    const filter = new ProfileFilter();

    API.Profiles.Search(filter, true).then((profiles) => {
      this.profiles = profiles;
    });
  }

  get directors(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Principal);
  }

  get agents(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Agent);
  }

  get propertyManagers(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PropertyManager);
  }

  get support(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PersonalAssistant);
  }
}
